import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field, Control, Button, Icon, Tab } from "rbx";
import { useQuery } from "react-apollo";

import { Switch, useLocation, Route, Link, useHistory } from "react-router-dom";

import Summary from "./routes/Summary";
import Billing from "./routes/Billing";

import { useLocalStorage, useSystemCodes } from "../../../utils/hooks";
import { CURRENT_USER_QUERY } from "../../../graphql/Users/Users.graphql";

import { OrderReplicates, OrderDuplicates } from "../../../components/Orders";
import { Loader } from "../../../components/loaders";

import { ModalContext } from "../../../components/ModalProvider";

import NewOrderOptions from "./NewOrderOptions";

import Authorization, {
  useAuthorization
} from "../../../components/Authorization";
import { ourToast as toast } from "../../../utils";

const BillingAuth = Authorization(["ADMIN", "FIN"]);

const OrderOptionsModal = ({
  orderReplicates,
  handleChangeOrderReplicates,
  duplicate,
  daysOfWeek,
  handleDuplicateChange,
  handleChangeDaysOfWeek,
  durationInWeeks,
  handleDurationChange
}) => (
  <div>
    <OrderReplicates
      replicates={orderReplicates}
      onChange={handleChangeOrderReplicates}
    />
    <hr />
    <OrderDuplicates
      daysOfWeek={daysOfWeek}
      duplicate={duplicate}
      durationInWeeks={durationInWeeks}
      onChange={handleDuplicateChange}
      onChangeDaysOfWeek={handleChangeDaysOfWeek}
      onDurationChange={handleDurationChange}
    />
  </div>
);

OrderOptionsModal.propTypes = {
  orderReplicates: PropTypes.number,
  handleChangeOrderReplicates: PropTypes.func,
  duplicate: PropTypes.bool,
  daysOfWeek: PropTypes.array,
  handleDuplicateChange: PropTypes.func,
  handleChangeDaysOfWeek: PropTypes.func,
  durationInWeeks: PropTypes.number,
  handleDurationChange: PropTypes.func
};

const INITIAL_STATE = {
  CustomerRecIdRef: "",
  RouteRecIdRef: "",
  LoadTypeRecIdRef: "",
  StartLocationRecIdRef: "",
  PickupLocationRecIdRef: "",
  DeliveryLocationRecIdRef: "",
  EndingLocationRecIdRef: "",
  Customer_SI: "",
  StartLoc_SI: "",
  PickupLoc_SI: "",
  DeliveryLoc_SI: "",
  EndLoc_SI: "",
  EstimatedLoad: "",
  EstimatedTravel: "",
  EstimatedUload: "",
  OrderDate: new Date(),
  OrderTime: "",
  RequestedDeliveryDate: "",
  RequestedDeliveryTime: "",
  ScheduledDeliveryDate: "",
  ScheduledDeliveryTime: "",
  PickupDate: "",
  PickupTime: "",
  BillToRecIdRef: null,
  PaymentMethodRecIdRef: "",
  CustRef: "",
  CompanyId: "",
  OrderDateTime: new Date(),
  RequestedDeliveryDateTime: new Date(),
  PickupDateTime: new Date(),
  ScheduledDeliveryDateTime: new Date(),
  CreatedBy: null,
  OrderedBy: "",
  BookingCodeRecIdRef: "",
  LoadedMiles: "",
  TariffRecIdRef: "",
  BillingNotes: "",
  OrderNotes: "",
  NonBill: false,
  DeliveryLocation: null,
  PickupLocation: null,
  RouteSelected: null,
  PaymentTermsRecIdRef: ""
};

const NewOrderPage = () => {
  const location = useLocation();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const isAuthorized = useAuthorization(["ADMIN", "FIN"]);
  const { setModalOpen } = useContext(ModalContext);
  const SystemCodes = useSystemCodes({
    Category: "Order",
    CodeName: "OrderStatus",
    CodeId: "U"
  });
  const { data: currentUser } = useQuery(CURRENT_USER_QUERY);

  const [inputs, setInputs, clearInputs] = useLocalStorage(
    "NEW_ORDER",
    INITIAL_STATE
  );

  const [orderDetails, setOrderDetails, clearOrderDetails] = useLocalStorage(
    "NEW_ORDER_ORDER_DETAILS",
    []
  );
  useEffect(() => {
    if (currentUser && currentUser.Me && !inputs.CreatedBy) {
      setInputs({ ...inputs, CreatedBy: currentUser.Me.UserId });
    }
    if (SystemCodes?.data?.length > 0 && !inputs.StatusRecIdRef) {
      setInputs({ ...inputs, StatusRecIdRef: SystemCodes.data[0].RecId });
    }
  }, [SystemCodes, SystemCodes.data, currentUser, inputs, setInputs]);

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;

    const updates = { ...inputs, [e.target.name]: value };

    if (
      e.target.name === "CustomerRecIdRef" ||
      e.target.name === "LoadTypeRecIdRef"
    ) {
      updates[e.target.name] = value ? parseInt(value) : null;
    }

    setInputs(updates);
  };

  const handleChangeCustomer = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    const updates = { ...INITIAL_STATE };
    updates[e.target.name] = value ? parseInt(value) : null;
    setInputs(updates);
  };

  const handleChangeRoute = routeData => {
    console.log(routeData);
    setInputs({
      ...inputs,
      ...routeData
    });
  };
  const handleChangeTime = timeData => {
    setInputs({ ...inputs, ...timeData });
  };
  const handleReset = () => {
    clearInputs();
    clearOrderDetails();
  };
  const handleSave = async () => {
    if (inputs.RequestedDeliveryDate && inputs.BookingCodeRecIdRef) {
      setModalOpen(
        true,
        <NewOrderOptions
          newOrder={inputs}
          newOrderDetails={orderDetails}
          onCancel={() => setModalOpen(false, "")}
          onComplete={() => {
            setLoading(false);
            handleReset();
          }}
          onSubmit={() => {
            setModalOpen(false, "");
            setLoading(true);
          }}
        />
      );
    } else {
      if (!inputs.RequestedDeliveryDate) {
        toast.error("Requested Delivery Date is required.");
      }
      if (!inputs.BookingCodeRecIdRef) {
        toast.error("Booking Code is required.");
      }
      toast.error("Form Arguments Invalid.");
    }
  };
  return (
    <div className="order-page">
      <header className="page-head">
        <div className="page-head-start" />
        <div className="page-head-end">
          <Field kind="group">
            <Control>
              <Button
                color="primary"
                disabled={loading}
                size="small"
                state={loading ? "loading" : ""}
                onClick={handleReset}
              >
                <Icon>
                  <FontAwesomeIcon icon="broom" />
                </Icon>
                <span>Clear</span>
              </Button>
            </Control>
            <Control>
              <Button
                color="danger"
                disabled={loading}
                size="small"
                state={loading ? "loading" : ""}
                onClick={() => {
                  handleReset();
                  history.push("/dispatch/orders");
                }}
              >
                <Icon>
                  <FontAwesomeIcon icon="times" />
                </Icon>
                <span>Cancel</span>
              </Button>
            </Control>
            <Control>
              <Button
                color="success"
                disabled={loading}
                size="small"
                state={loading ? "loading" : ""}
                onClick={handleSave}
              >
                <Icon>
                  <FontAwesomeIcon icon="save" />
                </Icon>
                <span>Save</span>
              </Button>
            </Control>
          </Field>
        </div>
      </header>

      {loading ? (
        <Loader />
      ) : (
        <div>
          <Tab.Group kind="boxed">
            <Tab
              active={location.pathname === "/dispatch/orders/new"}
              as={Link}
              tabIndex="-1"
              to="/dispatch/orders/new"
            >
              <span>Summary</span>
            </Tab>
            {isAuthorized && (
              <Tab
                active={location.pathname.includes("billing")}
                as={Link}
                style={{
                  cursor: inputs.RouteRecIdRef === "" ? "no-drop" : "pointer"
                }}
                tabIndex="-1"
                to={
                  inputs.RouteRecIdRef !== "" && "/dispatch/orders/new/billing"
                }
              >
                <span>Billing</span>
              </Tab>
            )}
          </Tab.Group>
          <Switch>
            <Route exact path="/dispatch/orders/new">
              <Summary
                adding
                editing
                handleChangeCustomer={handleChangeCustomer}
                handleChangeRoute={handleChangeRoute}
                order={inputs}
                orderDetails={orderDetails}
                setOrderDetails={setOrderDetails}
                onChange={handleChange}
                onTimeFramesChange={handleChangeTime}
              />
            </Route>
            <Route path="/dispatch/orders/new/billing">
              {BillingAuth(Billing, {
                order: inputs,
                onChange: handleChange,
                editing: true,
                adding: true
              })}
            </Route>
          </Switch>
        </div>
      )}
    </div>
  );
};

NewOrderPage.propTypes = {};

export default NewOrderPage;
